export const WELLBEING_WELL_DONE: string[] = [
  "You have just completed your first wellbeing check.",
  "The more media you consume and the more times you complete your wellness check the A.I will learn over time curating more helpful information such as articles, videos and podcasts to help improve your wellbeing and mental health.",
  "A resilience score will be given after completing your mood tracker and wellness check for you to work on.",
  "Other activities like breathing exercise, CBT techniques, digital journaling and habit tracking are all available to help you improve your resilience score.",
];
